module.exports = __webpack_public_path__ + "c74d83e9ccdbd1d0f30de9a73ec5276a.svg";